import { __module as r } from "./index.es507.js";
import { __require as i } from "./index.es508.js";
import { __require as p } from "./index.es509.js";
import { __require as s } from "./index.es510.js";
var e;
function f() {
  if (e) return r.exports;
  if (e = 1, process.env.NODE_ENV !== "production") {
    var o = i(), t = !0;
    r.exports = /* @__PURE__ */ p()(o.isElement, t);
  } else
    r.exports = /* @__PURE__ */ s()();
  return r.exports;
}
export {
  f as __require
};
//# sourceMappingURL=index.es479.js.map
